export async function fetchBlobFile(fileName, clientKey) {
    const functionUrl = process.env.REACT_APP_BLOB_API_URL;

    try {
        const response = await fetch(functionUrl, {
            method: "POST",
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Headers": "content-type",
                "Content-Type": "application/json",
                "Access-Control-Allow-Methods": "GET, POST",
                "x-functions-key": clientKey
            },
            body: JSON.stringify({ fileName }) // Enviar el nombre del archivo en el cuerpo de la solicitud
        });

        if (!response.ok) {
            throw new Error(`Error al obtener el archivo: ${response.statusText}`);
        }

        return await response.blob(); // Devuelve el archivo como Blob
    } catch (error) {
        console.error("Error:", error);
        throw error;
    }
}
